import type { DailyPerformance } from '@/domain/performance/Performance'
import type { PerformanceRepository } from '@/domain/performance/PerformanceRepository'
import type { AgentId } from '@/domain/shared/Brand'
import type {
  HomeRevenueSummary,
  PerformanceService,
} from './PerformanceService'

export class DefaultPerformanceService implements PerformanceService {
  constructor(private readonly performanceRepository: PerformanceRepository) {}

  async getHomeRevenueSummary(agentId: AgentId): Promise<HomeRevenueSummary> {
    const [monthly, lastMonth] = await Promise.all([
      this.performanceRepository.getMonthlyEarnings(agentId),
      this.performanceRepository.getLastMonthRevenue(agentId),
    ])

    return {
      monthly,
      lastMonth,
    }
  }

  async getLast7DaysPerformance(agentId: AgentId): Promise<DailyPerformance[]> {
    return this.performanceRepository.getLast7DaysEarnings(agentId)
  }
}
